const languageOptionsForCountry = {
  JP: [
    {
      value: 'ja-JP',
      label: '日本語',
    },
  ],
  MX: [
    {
      value: 'es-MX',
      label: 'Español',
    },
  ],
  CR: [
    {
      value: 'es-CR',
      label: 'Español',
    },
  ],
};

function getLanguageOptionsForCountry(country) {
  const common = [
    {
      value: 'en-US',
      label: 'English',
    },
  ];
  let countryOptions = languageOptionsForCountry[country] || [];
  return [...common, ...countryOptions];
}

export { getLanguageOptionsForCountry };
